<template lang="pug">
modal#reject-envelope-modal(
  :no-footer='true'
  :title='$t("modal.rejectEnvelope.title")'
  ref='modal'
  size='sm'
)
  p.justify-center {{ $t('modal.rejectEnvelope.message') }}
  ValidationObserver(ref='form')
    ValidationProvider(
      :custom-messages='customMessagesMotivo'
      rules='required'
      v-slot='{ errors }'
    )
      textarea.form-control(
        :class='{ "border border-danger": errors[0] }'
        :placeholder='$t("modal.rejectEnvelope.enterYourReason")'
        style='height: 120px'
        v-model='form.reason'
      )
      small.text.text-danger.d-flex(v-if='errors.length > 0')
        icon(name='xmark')
        span.text.ms-2 {{ errors[0] }}
    .text-end.mt-3
      button.btn.btn-secondary(@click='close' type='button')
        | {{ $t('button.cancel') }}
      button.btn.btn-danger.ms-2(
        @click='rejectEnvelope'
        style='border-width: 1px'
        type='button'
      )
        | {{ $t('button.reject') }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import RecipientsService from '@/modules/business/services/http/envelopes/RecipientsService';
import alert from '@/modules/account/common/alert';
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'RejectEnvelopeModal',
  components: {
    Modal,
    Icon,
  },
  props: {
    token: [Number, String],
  },
  data() {
    return {
      form: {
        reason: '',
      },
      customMessagesMotivo: {
        required: this.$t('modal.rejectEnvelope.customMessageReason'),
      },
    };
  },
  methods: {
    close() {
      if (this.$refs.modal) {
        this.$refs.modal.close();
      }
    },
    async rejectEnvelope() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        this.$loading(true);
        RecipientsService.rejectEnvelope(this.token, this.form.reason)
          .then((response) => {
            this.$emit('refresh', response);
          })
          .catch((error) => {
            alert.fireAlert(
              `${this.$t('modal.rejectEnvelope.error')} ${
                error.response.data.message
              }`,
              {
                classes: 'alert-danger',
                styles:
                  'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
                tag: 'httpAlert',
                icon: 'triangle-exclamation',
              }
            );
          })
          .finally(() => {
            this.close();
            this.$loading(false);
          });
      }
    },
  },
};
</script>
